import { render, staticRenderFns } from "./AddStep2.vue?vue&type=template&id=3b1fc7ea&scoped=true&"
import script from "./AddStep2.vue?vue&type=script&lang=js&"
export * from "./AddStep2.vue?vue&type=script&lang=js&"
import style0 from "./AddStep2.vue?vue&type=style&index=0&id=3b1fc7ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1fc7ea",
  null
  
)

export default component.exports